import { FC } from 'react';
import styled from 'styled-components';
import { GenericContainerCard, SideSpace } from '../UtilitiesMatchMobile/GenericCssComponentMatchMobile';
import CenterInfoFightRendering from '../UtilitiesMatchMobile/GenericRendering/CenterInfoFightRendering';
import RenderWrestlerWhenThreeInSpace from './RenderWrestlerBySpaceAndNumber/RenderWrestlerWhenThreeInSpace';
import RenderingMatchWithConditionExtended from '../UtilitiesMatchMobile/RenderingMatchWithConditionExtended';
import { Match, WrestlerInMatch } from '../../../../types';

export const WrapperSideSpace = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

interface ThreeVsThreeMatchRenderProps {
    matchInfo: Match;
    withWinner?: boolean;
    isExpanded?: boolean;
}

interface WrestlerWithTeam extends WrestlerInMatch {
    team?: number;
}

const ThreeVsThreeMatchRender: FC<ThreeVsThreeMatchRenderProps> = ({ matchInfo, withWinner = false, isExpanded = false }) => {
    // wrestlers1 sono i matchinfo.wrestlers con team 1
    // wrestlers2 sono i matchinfo.wrestlers con team 2
    const wrestlers1 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 1);
    const wrestlers2 = matchInfo.wrestlers.filter((wrestler: WrestlerWithTeam) => wrestler.team === 2);

    function renderGenericContainerCard() {
        return (
            <GenericContainerCard className='three-vs-three-match-render'
            height={isExpanded ? '80%' : '100%'}
            >
                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        {wrestlers1.map((wrestler, index) => (
                            <RenderWrestlerWhenThreeInSpace wrestler={wrestler} side='left' key={index} withWinner={withWinner} />
                        ))}
                    </WrapperSideSpace>

                </SideSpace>
                <CenterInfoFightRendering matchInfo={matchInfo} typeMatch='Three-vs-Three' />
                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        {wrestlers2.map((wrestler, index) => (
                            <RenderWrestlerWhenThreeInSpace wrestler={wrestler} side='right' key={index} withWinner={withWinner} />
                        ))}
                    </WrapperSideSpace>

                </SideSpace>
            </GenericContainerCard>
        )
    }

     return (
        RenderingMatchWithConditionExtended({ renderGenericContainerCard, isExpanded, matchInfo })
    )
}

export default ThreeVsThreeMatchRender;
